<template>
  <div class="mt-4 text-center sc overflow-auto w-auto h-50">
    <div>
      <span class="h1 ">Transaction History</span>
    </div>
    <div class="m-3 mt-3">
      <b-form>
        <b-row class="mb-4">
          <b-col xl="12" class="d-flex">
            <label for="rowLimit" class="font-weight-900 mt-2 mr-3 ">Period:</label>
            <b-form-select
                id="rowLimit"
                v-model="transactionHistoryForm.period"
                :options="periodOption"
                value-field="key"
                text-field="label"
            ></b-form-select>
            <base-button type="primary" title="Show Details" size="sm" v-on:click="getTransactionHistory()"
                         class="transaction-history-button" :loading="loadingStatus">
              <i v-if="!loadingStatus" class="fas fa-search"> </i>
            </base-button>

          </b-col>
        </b-row>
      </b-form>
      <b-row>
        <b-col xl="4" lg="4" md="4" sm="12">

        </b-col>
        <b-col xl="8" lg="8" md="8" sm="12 customer-table-select">
          <b-form-group
              label=""
              label-for="filter-input"
              label-align-sm="right"
              label-size="sm "
              class="mb-0"
          >
            <b-input-group size="sm">
              <label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
              <b-form-input
                  label="Search"
                  id="filter-input"
                  v-model="filter"
                  class="mb-4"
              ></b-form-input>

            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="grey-sideborder">
        <b-table
            striped hover
            :items="tableData"
            :fields="tableColumns"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            head-variant="light"
            table-class="text-nowrap"
            class="primary-table"
            sticky-header="true"
            show-empty
            responsive
            small
            @filtered="onFiltered"
        >
          <template #cell(method)="row">
          <span v-if="row.detailsShowing "
                @click="row.toggleDetails">
                <i class="fa fa-minus-circle text-danger"></i>
          {{ row.value }}
          </span>
            <span @click="row.toggleDetails" v-if="!row.detailsShowing">
             <i class="fa fa-plus-circle text-primary"></i>
          {{ row.value }}
          </span>
          </template>

          <template #row-details="row">
            <div class="d-flex">
              <span class="h4 font-weight-900 mr-4">Date</span>
              <span class="text-sm">{{ row.item.actiondate }}</span>
            </div>
            <hr class="mt-3 mb-3">
            <div class="d-flex">
              <span class="h4 font-weight-900 mr-4">Message</span>
              <span class="text-sm responsive-table" style="min-width: 269px;max-width: 457px;">
              <div v-highlight class="overflow-auto w-auto h-auto">
                  <pre><code class="json">{{
                      fJson(row.item.response)
                    }}</code></pre>
              </div>
            </span>

              <!--<span class="text-sm " style="width: 100px;">-->
              <!--<span class="h5">2G_3G_Status:</span> {{row.item.response['2G_3G_Status']}}<br>-->
              <!--<span class="h5">CFB_Active:</span> {{row.item.response['CFB_Active']}}<br>-->
              <!--<span class="h5">CFB_Number:</span> {{row.item.response['CFB_Number']}}<br>-->
              <!--<span class="h5">CFB_Provisioned:</span> {{row.item.response['CFB_Provisioned']}}<br>-->
              <!--<span class="h5">CFNA_Active:</span> {{row.item.response['CFNA_Active']}}<br>-->
              <!--<span class="h5">CFNR_Number:</span> {{row.item.response['CFNR_Number']}}<br>-->
              <!--<span class="h5">CFNR_Provisioned:</span> {{row.item.response['CFNR_Provisioned']}}<br>-->
              <!--<span class="h5">CFU_Active:</span> {{row.item.response['CFU_Active']}}<br>-->
              <!--<span class="h5">CFU_Number:</span> {{row.item.response['CFU_Number']}}<br>-->
              <!--<span class="h5">CFU_Provisioned:</span> {{row.item.response['CFU_Provisioned']}}<br>-->
              <!--<span class="h5">CLEARWATER:</span> {{row.item.response['CLEARWATER']}}<br>-->
              <!--<span class="h5">Call_Waiting:</span> {{row.item.response['Call_Waiting']}}<br>-->
              <!--<span class="h5">Clip:</span> {{row.item.response['Clip']}}<br>-->
              <!--<span class="h5">DATA_PLAN:</span> {{row.item.response['DATA_PLAN']}}<br>-->
              <!--<span class="h5">DATA_PLAN_DESC:</span> {{row.item.response['DATA_PLAN_DESC']}}<br>-->
              <!--<span class="h5">Data:</span> {{row.item.response['Data']}}<br>-->
              <!--<span class="h5">ENUM:</span> {{row.item.response['ENUM']}}<br>-->
              <!--<span class="h5">HLR_Profile:</span> {{row.item.response['HLR_Profile']}}<br>-->
              <!--<span class="h5">HSS:</span> {{row.item.response['HSS']}}<br>-->
              <!--<span class="h5">HSS_Profile:</span> {{row.item.response['HSS_Profile']}}<br>-->
              <!--<span class="h5">ICCID:</span> {{row.item.response['ICCID']}}<br>-->
              <!--<span class="h5">LocaDataOnly:</span> {{row.item.response['LocaDataOnly']}}<br>-->
              <!--<span class="h5">MMS:</span> {{row.item.response['MMS']}}<br>-->
              <!--<span class="h5">MSISDN:</span> {{row.item.response['MSISDN']}}<br>-->
              <!--<span class="h5">OTA:</span> {{row.item.response['OTA']}}<br>-->
              <!--<span class="h5">Private_Identity:</span> {{row.item.response['Private_Identity']}}<br>-->
              <!--<span class="h5">Product:</span> {{row.item.response['Product']}}<br>-->
              <!--<span class="h5">Product_Description:</span> {{row.item.response['Product_Description']}}<br>-->
              <!--<span class="h5">SMS:</span> {{row.item.response['SMS']}}<br>-->
              <!--<span class="h5">Status</span> {{row.item.response['Status']}}<br>-->
              <!--<span class="h5">Subscriber_Name:</span> {{row.item.response['Subscriber_Name']}}<br>-->

              <!--</span>-->
            </div>
          </template>
        </b-table>
      </div>
    </div>

  </div>
</template>

<script>
import AuthService from "@/common/api-services/auth-service";
import coreutils from "@/common/coreutils";

export default {
  name: "Transaction-History",
  data() {
    return {
      transactionHistoryForm: {
        period: '15_min'
      },
      periodOption: [
        {key: '15_min', label: 'Last 15 mins'},
        {key: '1_hr', label: 'Last 1 hour'},
        {key: '1_day', label: 'Last 1 day'},
        {key: '1_wk', label: 'Last 1 week'},
        {key: '1_month', label: 'Last 1 month'},
      ],
      loadingStatus: false,
      totalRows: 0,
      currentPage: 1,
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      tableColumns: [
        {key: 'method', label: 'Action', sortable: true, sortDirection: 'desc'},
      ],
      tableData: [],
      localData: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      startPage: 1,
      fromPage: 10,
      lastPage: 1,
    }
  },
  mounted() {
    //TODO: don't get transaction history without a user clicking the menu.
    //this.getTransactionHistory();
  },
  methods: {

    fJson(text) {
      return coreutils.formatJson(text);
    },

    getTransactionHistory() {
      this.loadingStatus = true;
      this.tableData = [];
      AuthService.getTransactionHistory(this.transactionHistoryForm.period).then(res => {
        this.loadingStatus = false;
        if (res.includes('FAIL')) {
          this.$toast.error(res)
        } else if (res !== 'No data found') {
          this.tableData = res;
          this.totalRows = res.length;
          this.perPage = res.length;
        }
      })
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

  }

}
</script>
